import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ObrasService } from '../../services/obras.service';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import {ValidatorService} from '../../services/tools/validator.service';
import {Globals} from './../../services/tools/Globals.service';
declare var $;


@Component({
  selector: 'app-catalogo-obras',
  templateUrl: './catalogo-obras.component.html',
  styleUrls: ['./catalogo-obras.component.scss']
})
export class CatalogoObrasComponent implements OnInit {

  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;

  obras: any[];
  inversionistas: any[];
  searchText: any = '';
  obraSelected: any;
  obraChecked: any;
  inversionistasSelected :any = [];
  inversionistasGruposSelected :any = [];
  mostrarListado: any = true;
  errors: any = {};
  searchProcess: any;
  statuses: any = {};
  paginate: any = {};
  currentPage: any = 1;
  lastPage: any = 1;
  processing: any = false;
  alterTable:any = 'starting';
  exportingCSV: any = false;

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  constructor(  private obrasService: ObrasService,
                private validatorService: ValidatorService,
                private helperService: HelpersService,
                private globals: Globals) {
    // se colocó esto para que el this dentro de delete sea el del scope global
    this.deleteObra = this.deleteObra.bind(this);
    this.resetObraSelected = this.resetObraSelected.bind(this);
    this.habilitar = this.habilitar.bind(this);
    this.statuses = this.obrasService.getObrasStatus();
    this.getObras();

   }

  ngOnInit() {
    this.globals.passwordActivate = false;
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }

  resetObraSelected() {
    this.obraSelected = undefined;
    this.inversionistasSelected = [];
    this.inversionistasGruposSelected = [];
    this.errors = {};
  }

  startObraSelected() {
    this.resetObraSelected();
    this.obraSelected = this.obrasService.getDefaultSchedule();
    this.inversionistasSelected = [];
    this.inversionistasGruposSelected = [];
  }

  selectObra(obra) {
    this.resetObraSelected();
    const obraCloned = JSON.parse(JSON.stringify( obra ));
    const inversionistas_obras_cloned = JSON.parse(JSON.stringify( obra.inversionistas_obras ));
    const inversionistas_obras_grupos_cloned = JSON.parse(JSON.stringify( obra.inversionistas_obras_grupos ));
    this.obraSelected = obraCloned;
    this.inversionistasSelected = inversionistas_obras_cloned;
    this.inversionistasGruposSelected = inversionistas_obras_grupos_cloned;
  }

  SelectedObraClass(obra) {

    return (this.validatorService.required(this.obraSelected) && this.obraSelected.idObras === obra.idObras) ? 'active' : '';
  }

  getObraStatusNombre(id) {
    return this.obrasService.getObraStatusByid(id).nombre;
  }

  confirmDeleteObra() {
    this.confirmModal.open({
      'title': 'Eliminar obra',
      'description': '¿Está seguro que desea eliminar esta Obra?',
      'callback': this.deleteObra
    });
  }

  deleteObra() {
    this.processing = true;
    this.obrasService.deleteObra(this.obraSelected.idObras)
      .subscribe(
        response => {
          this.processing = false;
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha eliminado correctamente la obra seleccionada'
          });

          this.getObras();
          this.resetObraSelected();
      }, error => {
          this.processing = false;
          // resuelve los errores 403 y 500
          this.helperService.httpGlobalError(error);
      });
  }

  searchObra(page = null) {
    if (this.searchProcess) {
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 1) {
      this.searchProcess = this.obrasService.searchObraWithInversionistas(this.searchText, page)
          .subscribe(response => {
            const content = response.json().content;
            // this.resetObraSelected();
            this.obras = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.obras.length > 0)? false: 'not_found';
          }, error => {
            // resuelve los errores 403 y 500
            this.helperService.httpGlobalError(error, false);
          });
    } else {
      this.getObras();
    }
  }

  getObras(page = null) {
    this.searchProcess = this.obrasService.getObrasWithInversionistas(page)
      .subscribe(response => {
        const content = response.json().content;
        this.obras = content.data;
        console.log("datos",this.obras);
        this.startPaginate(content);
        this.alterTable = (this.obras.length > 0)? false: 'not_result';
        this.searchProcess = false;
      }, error => {
        // resuelve los errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  createObra() {
      if (this.validatorService.required(this.errors['inversionistas'])) {
          console.log('error en inversionista');
          return false;
      }

      this.errors = [];
      this.errors = this.obrasService.validateObra(this.obraSelected);

      if (!$.isEmptyObject(this.errors)) {
        this.helperService.notificationErrorArray(this.errors);
        return false;
      }

    this.processing = true;
    this.obraSelected.activa = (this.obraSelected.activa) ? 1 : 0;
    this.obraSelected.es_emisora = (this.obraSelected.es_emisora) ? 1 : 0;
    this.obraSelected.inversionistas_obras = this.inversionistasSelected;
    this.obraSelected.inversionistas_obras_grupos = this.inversionistasGruposSelected;
    this.obraSelected.fechaInicio = $('#fechaInicio').val();

    this.obrasService.createObra(this.obraSelected)
      .subscribe(response => {

        const respuesta = response.json();
        console.log('respuesta', respuesta);
        this.processing = false;
        if (respuesta.success) {
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha creado correctamente la obra'
          });

          this.obraSelected.idObras = respuesta.content.idObra;
          this.goPage(1);
        }
      }, error => {
        this.processing = false;

        // resuelve los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
        }

        if (error.status == 400 || error.status == 500) {
          this.errorModal.open({
            'title': 'Error!',
            'description': 'No se ha podido guardar la obra, inténtelo más tarde'
          });
        }
      });
  }

  updateObra() {
      if (this.validatorService.required(this.errors['inversionistas'])) {
          console.log('error en inversionista');
          return false;
      }
      this.errors = [];
      this.errors = this.obrasService.validateObra(this.obraSelected);
      if (!$.isEmptyObject(this.errors)) {
          this.helperService.notificationErrorArray(this.errors);
          return false;
      }
    this.processing = true;
    this.obraSelected.activa = (this.obraSelected.activa) ? 1 : 0;
    this.obraSelected.es_emisora = (this.obraSelected.es_emisora) ? 1 : 0;
    this.obraSelected.inversionistas_obras = this.inversionistasSelected;
    this.obraSelected.inversionistas_obras_grupos = this.inversionistasGruposSelected;
    this.obraSelected.fechaInicio = $('#fechaInicio').val();

    this.obrasService.updateObra(this.obraSelected, this.obraSelected.idObras)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.helperService.notification('¡Éxito!', 'Se ha editado correctamente la obra', 'success');
          this.goPage(this.currentPage);
        } else {
          
          this.errorModal.open({
            'title': 'Error!',
            'description': 'No se ha podido guardar la obra, inténtelo más tarde'
          });
        }
      }, error => {
        this.processing = false;
        // resuelve los errores 403 y 500
        this.helperService.httpGlobalError(error, true);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notificationErrorDefault();
        }
      });
  }

  setBackendErrors(errors: any []) {
    let temp_errors = [];
    Object.keys(errors).forEach(function(key) {
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  obraSelectedWithId() {
    if (! this.obraSelected) {
      return false;
    }

    return (this.obraSelected.idObras);
  }

  cancelarObraSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetObraSelected
    });
  }

  writePermission() {
    return this.obrasService.writePermission();
  }

  canExport() {
    return this.obrasService.canExport();
  }

  confirmHabilitar(obra) {
    this.obraChecked = obra;

    const title = (this.obraChecked.activa == 1) ? 'Desactivar' : 'Activar';
    const body = (this.obraChecked.activa == 1) ? 'desactivará' : 'activará';

    this.confirmModal.open({
      'title': title + ' la obra',
      'description': 'La siguiente obra se ' + body + ': ' + this.obraChecked.nombreObra,
      'callback': this.habilitar
    });

    return false;
  }

  habilitar() {
    const title = (this.obraChecked.activa == 1) ? 'desactivado' : 'activado';
    console.log("Lo que se muestgra es = ",this.obraChecked);
    this.obraChecked.activa = (this.obraChecked.activa == 1) ? 0 : 1;
    this.obrasService.updateObra(this.obraChecked, this.obraChecked.idObras)
        .subscribe( response => {
          if (response.json().success) {
            this.helperService.notification('¡Éxito!', 'Se ha ' + title + '  la obra', 'success');
          } else {
            this.setBackendErrors(response.json().content);
            this.errorModal.open({
              'title': 'Error!',
              'description': 'No se ha podido ' + title +  '  la obra, inténtelo más tarde'
            });
          }
        }, error => {
          // resuelve los errores 403 y 500
          this.helperService.httpGlobalError(error);

          if (error.status == 400) {
            this.helperService.notification('ERROR', 'No se ha podido ' + title +  '  la obra, inténtelo más tarde', 'error');
          }
        });
  }

  exportCSV() {
    this.exportingCSV = true;
    this.obrasService.export(this.searchText)
      .subscribe((response) => {
        this.exportingCSV = false;
      }, error => {
        // resuelve los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  modalCallback(callback) {
    callback();
  }

  mainContainerClass() {
    return (this.mostrarListado) ? 'col-12' : 'offset-2 col-8';
  }

  mainTableClass() {
    return (this.mostrarListado) ? 'col-8' : 'col-4';
  }

  mainDetailsClass() {
    return (this.mostrarListado) ? 'col-4' : 'col-8';
  }

  startPaginate(content) {
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for (let i = 1; i <= this.paginate.last_page; i++) {
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage() {
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage() {
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    if (this.searchText) {
      this.searchObra(page);
    } else {
      this.getObras(page);
    }
  }

  changeSwitchListado() {
    if (!this.mostrarListado) {
      this.obraSelected = this.obrasService.getDefaultSchedule();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-obras/catalogo-obras.component.ts